<template>
  <div class="status" :class="computedClassModifier"><slot /></div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'GlStatus',
  props: {
    size: {
      type: String,
      validate(value) {
        return ['sm', 'lg'].indexOf(value) !== -1
      },
      default: '',
    },
    variant: {
      type: String,
      validate(value) {
        return ['outline-primary', 'danger', 'info'].indexOf(value) !== -1
      },
      default: '',
    },
  },
  setup(props) {
    const computedClassModifier = computed(() => {
      const baseClassName = 'status'
      const modifiers = [`${baseClassName}--${props.variant}`]
      if (props.size) modifiers.push(`${baseClassName}--${props.size}`)
      return modifiers
    })

    return {
      computedClassModifier,
    }
  },
}
</script>

<style lang="scss" scoped>
.status {
  $this: &;

  align-items: center;
  background-color: transparent;
  border: 0;
  border-radius: 30px;
  color: rgba(0, 0, 0, 0.87);
  display: inline-flex;
  font-family: $font-family;
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  line-height: 1;
  min-height: 40px;
  min-width: 150px;
  outline: none;
  padding: 4px 32px;
  text-align: center;
  text-transform: uppercase;

  &--danger {
    background-color: $color-red;
    color: #fff;
  }

  &--info {
    background-color: $color-blue;
    color: #fff;
  }

  &--outline-primary {
    background-image: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><defs><linearGradient id="Gradient" x1="100%" y1="50%" x2="0" y2="50%" gradientUnits="userSpaceOnUse"><stop stop-color="%23f3e485" offset="0"/><stop stop-color="%23b18145" offset="1"/></linearGradient></defs><rect x="0" y="0" height="100%" width="100%" rx="20" stroke-width="2" fill="transparent" stroke="url(%23Gradient)"/></svg>');
    color: #fff;

    &#{$this}--sm {
      background-image: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><defs><linearGradient id="Gradient" x1="100%" y1="50%" x2="0" y2="50%" gradientUnits="userSpaceOnUse"><stop stop-color="%23f3e485" offset="0"/><stop stop-color="%23b18145" offset="1"/></linearGradient></defs><rect x="0" y="0" height="100%" width="100%" rx="15" ry="15" stroke-width="2" fill="transparent" stroke="url(%23Gradient)"/></svg>');
    }

    &#{$this}--lg {
      background-image: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><defs><linearGradient id="Gradient" x1="100%" y1="50%" x2="0" y2="50%" gradientUnits="userSpaceOnUse"><stop stop-color="%23f3e485" offset="0"/><stop stop-color="%23b18145" offset="1"/></linearGradient></defs><rect x="0" y="0" height="100%" width="100%" rx="30" ry="30" stroke-width="2" fill="transparent" stroke="url(%23Gradient)"/></svg>');
    }
  }

  &--sm {
    font-size: 12px;
    min-height: 30px;
    padding-left: 24px;
    padding-right: 24px;
  }

  &--lg {
    font-size: 16px;
    min-height: 60px;
  }
}
</style>
